var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { attrs: { id: "pagination" } },
        [
          _c("el-pagination", {
            attrs: {
              small: "",
              layout: "prev, pager, next",
              pageCount: _vm.totalPages,
              "page-size": _vm.pageSize,
              total: _vm.getTotal,
              "current-page": _vm.pageNumber,
            },
            on: {
              "current-change": _vm.handleCurrentChange,
              "update:currentPage": function ($event) {
                _vm.pageNumber = $event
              },
              "update:current-page": function ($event) {
                _vm.pageNumber = $event
              },
            },
          }),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.getListLoading,
              expression: "getListLoading",
            },
          ],
          staticStyle: { width: "100%", "margin-bottom": "16px" },
          attrs: {
            id: "order-table",
            data: _vm.pagedTableData,
            border: "",
            fit: "",
            "highlight-current-row": "",
            "cell-style": { padding: "3px", height: "20px" },
            "header-cell-style": { paddingTop: "3px", paddingBottom: "3px" },
          },
          on: { "sort-change": _vm.handleSortData },
        },
        [
          _c("el-table-column", {
            attrs: {
              width: "110",
              align: "center",
              label: "ID",
              sortable: "",
              "sort-method": _vm.sortOrderId,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [_c("span", [_vm._v(_vm._s(row.orderId))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "class-name": "truncate",
              width: "140",
              align: "center",
              label: "Type",
              sortable: "",
              "sort-method": _vm.sortOrderType,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(_vm._s(row.orderTypeNavigation.inspTypeName)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "class-name": "truncate",
              width: "120",
              label: "Status",
              sortable: "",
              "sort-method": _vm.sortStatusId,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [_vm._v(" " + _vm._s(row.orderStatus) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              width: "120",
              label: "Appt. Date",
              sortable: "",
              "sort-method": _vm.sortApptDate,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("parseUtc")(row.appointmentDate)) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { width: "60", label: "Fee", align: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [_vm._v(" " + _vm._s(row.orderFee) + " ")]
                },
              },
            ]),
          }),
          _vm.isAdmin()
            ? _c("el-table-column", {
                attrs: { width: "80", label: "Vendor", align: "right" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [_vm._v(" " + _vm._s(row.vendorFee) + " ")]
                      },
                    },
                  ],
                  null,
                  false,
                  3691801821
                ),
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: {
              width: "110px",
              align: "center",
              label: "Inspected",
              sortable: "",
              "sort-method": _vm.sortInspectionDate,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm._f("parseUtc")(row.inspectionDate))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "class-name": "truncate",
              "min-width": "80px",
              align: "left",
              label: "Address",
              sortable: "",
              "sort-method": _vm.sortSubjectAddress,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [_c("span", [_vm._v(_vm._s(row.subjectAddress))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "class-name": "truncate",
              "min-width": "80px",
              align: "left",
              label: "City",
              sortable: "",
              "sort-method": _vm.sortSubjectCity,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [_c("span", [_vm._v(_vm._s(row.subjectCity))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              width: "70px",
              align: "left",
              label: "ST",
              sortable: "",
              "sort-method": _vm.sortSubjectState,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm._f("stateFilter")(row.subjectState))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "class-name": "truncate",
              "min-width": "80px",
              width: "120px",
              label: "Lender",
              sortable: "",
              "sort-method": _vm.sortLender,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [_c("span", [_vm._v(_vm._s(row.lenderName))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "class-name": "truncate",
              "min-width": "80px",
              width: "120px",
              label: "Client",
              sortable: "",
              "sort-method": _vm.sortClient,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [_c("span", [_vm._v(_vm._s(row.clientName))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "class-name": "truncate",
              "min-width": "80px",
              label: "Inspector",
              sortable: "",
              "sort-method": _vm.sortInspector,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [_c("span", [_vm._v(_vm._s(_vm.getVendorName(row)))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "Actions",
              width: "110",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "router-link",
                      { attrs: { to: "/orders/edit/" + row.orderId } },
                      [
                        _c("el-button", {
                          attrs: {
                            type: "primary",
                            circle: "",
                            plain: "",
                            size: "mini",
                            icon: "el-icon-edit",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("el-button", {
                      staticStyle: { "margin-left": "5px" },
                      attrs: {
                        type: "warning",
                        size: "mini",
                        icon: "el-icon-delete",
                        circle: "",
                        plain: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.showDeleteDialog(row.orderId)
                        },
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-confirm-vendor-fee",
          attrs: {
            "close-on-click-modal": false,
            title: _vm.deleteTitle,
            visible: _vm.dialogDeleteOrder,
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogDeleteOrder = $event
            },
          },
        },
        [
          _c("el-input", {
            attrs: {
              placeholder: "Add reason for Cancelling the order...",
              type: "textarea",
            },
            model: {
              value: _vm.deleteReason,
              callback: function ($$v) {
                _vm.deleteReason = $$v
              },
              expression: "deleteReason",
            },
          }),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "right",
                "margin-top": "15pt",
              },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "success", disabled: _vm.deleteReason === "" },
                  on: { click: _vm.handleDelete },
                },
                [
                  _vm._v(
                    " Cancel and Deactivate Order " +
                      _vm._s(_vm.deleteOrderId) +
                      " "
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning" },
                  on: { click: _vm.closeDeleteDialog },
                },
                [_vm._v(" Close ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }